import { ReactNode } from 'react';

import { Icon } from '@kanda-libs/ks-design-library';

import { ITEM_CLASS_NAMES, ITEM_PROPS } from './constants';

export interface CheckListElementItemProps {
  isLoading?: boolean;
  icon?: string;
  element: ReactNode;
}

const CheckListElementItem: React.FunctionComponent<CheckListElementItemProps> =
  function ({ isLoading = false, icon = 'check', element }) {
    const innerItemProps = { isLoading };
    return (
      <div className={ITEM_CLASS_NAMES.container}>
        <Icon icon={icon} {...ITEM_PROPS.icon} {...innerItemProps} />
        {element}
      </div>
    );
  };

export default CheckListElementItem;
